// This api will come in the next version

import {AuthConfig} from 'angular-oauth2-oidc';
import {environment} from 'environments/environment';

export const authPasswordFlowConfig: AuthConfig = {
    // Url of the Identity Provider
    issuer: environment.openid.issuer,

    // URL of the SPA to redirect the user to after login
    redirectUri: environment.openid.redirectUri,

    // URL of the SPA to redirect the user after silent refresh
    useSilentRefresh: true,
    silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
    sessionChecksEnabled: true,
    timeoutFactor: 0.75,

    // The SPA's id. The SPA is registerd with this id at the auth-server
    clientId: environment.openid.clientId,

    dummyClientSecret: 'geheim',

    // set the scope for the permissions the client should request
    // The first three are defined by OIDC. The 4th is a usecase-specific one
    scope: 'openid profile email',

    showDebugInformation: true,

    oidc: false,

    requireHttps: false,
};
